<template>
  <div class="NativeBarfooter">
    <van-row>
      <van-col span="6"><div @click="gotoHome"><i :class="(select=='home'?'iconfont iconshouye mainColor' :'iconfont iconshouye')" /></div></van-col>
      <van-col span="6"><div @click="gotoStore"><i :class="(select=='store'?'iconfont icongouwu mainColor' :'iconfont icongouwu')" /></div></van-col>
      <van-col span="6"><div @click="gotoTextbook"><i :class="(select=='textbook'?'iconfont iconqiapian mainColor' :'iconfont iconqiapian')" /></div></van-col>
      <van-col span="6"><div @click="gotoUsers"><i :class="(select=='users'?'iconfont iconwode mainColor' :'iconfont iconwode')" /></div></van-col>
    </van-row>
  </div>
</template>
<script>

export default {
  components: {
  },
  props: {
    select: {
      default: 'home' // home store textbook users
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
    gotoHome() {
      // 首页
      this.$router.replace('/home/index')
    },
    gotoStore() {
      // 购物
      this.$router.replace('/store/index?serKey=null')
    },
    gotoTextbook() {
      // 教材
      this.$router.replace('/textbook/index')
    },
    gotoUsers() {
      // 用户中心
      this.$router.replace('/users/index')
    }
  }
}
</script>
<style scoped>

</style>
